import { Component, ViewChild, Inject } from '@angular/core';
import { Http, RequestOptions, Headers, Response } from '@angular/http';
import { ShowCardsComponent } from '../app/show-cards/show-cards.component';
import { NewCardComponent } from '../app/new-card/new-card.component';

/*---------------------------------------------- Variables Liferay ----------------------------------------------*/
declare var i18nVS: any;
declare var cardsList: any;
declare var isSignedIn: any;
declare var topUpAvailablesCitiesListJson: any;
declare var idCiudadLiferay: any;

@Component({
	selector: 'app-student-desktop',
	templateUrl: './student-desktop.component.html',
	styleUrls: ['./student-desktop.component.css']
})

export class AppComponent {
    static readonly SELECTED_BUTTON_COLOR_CLASS = "disabled";
    static readonly UNSELECTED_BUTTON_COLOR_CLASS = "active";
    static readonly HIDDEN_CLASS = "hidden";
    
    i18nL = i18nVS;
    
    showCardsButtonClass = AppComponent.UNSELECTED_BUTTON_COLOR_CLASS;
    newCardsButtonClass = AppComponent.UNSELECTED_BUTTON_COLOR_CLASS;
    
    spinnerClass = '';
    visibilidadNewCard = false;    
    showComponentListCards = false;
    loadedComponent;
    
    @ViewChild(ShowCardsComponent) showCardsComponent: ShowCardsComponent;
    @ViewChild(NewCardComponent) newCardComponent: NewCardComponent;
    
    loginNeedTextClass = "invisible";
    
    // Lista de ciudades disponibles para hacer recargas
    topUpAvailablesCitiesList = null;
    
    // Si ya tenemos una tarjeta de estudiante no se debe poder solicitar una nueva
    showGetStudentCard = false;
    
    /*---------------------------------------------- Funciones ----------------------------------------------*/
    public showCards() {   
        this.resetClases();
        this.showCardsButtonClass = AppComponent.SELECTED_BUTTON_COLOR_CLASS;
        // tiene que mostrar el componente de show cards
        this.showComponentListCards = true;
        
        if (this.visibilidadNewCard) {
        	this.visibilidadNewCard = false;
        }
    }
    
    public onLoadStart(){
        this.spinnerClass='';
    }
    
    public onLoadStop(){
        this.spinnerClass=AppComponent.HIDDEN_CLASS;
    }
    
    public showNewCard () {
        this.resetClases();
        this.newCardsButtonClass = AppComponent.SELECTED_BUTTON_COLOR_CLASS;
        
        this.visibilidadNewCard = true;
        
        if (this.showComponentListCards) {
            this.showComponentListCards = false;
        }
    }
    
    private resetClases () {
        this.showCardsButtonClass = AppComponent.UNSELECTED_BUTTON_COLOR_CLASS;
        this.newCardsButtonClass = AppComponent.UNSELECTED_BUTTON_COLOR_CLASS;
    }
    
    /**
     * Llamada al ResourceCommand que proporciona las tarjetas del usuario
    */
    public initSelects() {
        this.ajaxRequest.post(cardsList, new Map<string, string>()).subscribe(
            res => { this.showCardsComponent.validateJSON(res, cardsList), this.newCardComponent.showGetNewStudentCard(res) }, 
            (err) => this.showCardsComponent.errorEnElJson(err, cardsList),
        	() => { this.showCardsComponent.initCardList() }
		);
    }
    
    public isTopupAvailableInCity(){
        return this.topUpAvailablesCitiesList.indexOf(idCiudadLiferay) > -1;
    }
    
    /*--------------------------------------------- Eventos ------------------------------------------------------*/
    ngOnInit() {
        this.initSelects();
        this.loadedComponent = false;
        if (!isSignedIn) {
        	this.loginNeedTextClass = "";
        }
        try {
            this.topUpAvailablesCitiesList = JSON.parse(topUpAvailablesCitiesListJson);
        } catch(err) {
            this.topUpAvailablesCitiesList = new Array();
        }
    }

    /*--------------------------------------------- Constructores ------------------------------------------------*/
    constructor(@Inject(Http) private ajaxRequest) {
        this.loadedComponent = true;
    }
}



// WEBPACK FOOTER //
// ./src/app/student-desktop.component.ts